import { z } from "zod";

export const userSchema = z.object({
    username: z.string().email({ message: 'validation.invalidEmail' }),
    fullName: z.string().max(50, { message: 'validation.invalidMaxLength' }),
    role: z.string(),
    phoneNo: z.string().nullish()
});

export type UserType = z.infer<typeof userSchema>;